module.exports = __webpack_public_path__ + "img/sixpackcarrier102.365b8825.jpg";